import { ButtonText } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { type RouteType } from '@/defs/route'
import { SCROLL_GALLERY } from '@/defs/scroll'
import { useLinkInternal } from '@/hooks/useLinkInternal'

type Props = {
  route: Partial<RouteType>
}

export const FiltersPanelResetButton = ({ route }: Props) => {
  const { buildRelative } = useLinkInternal()

  return (
    <ButtonText
      aria-label='Reset'
      as='LinkRoute'
      hover='warning'
      href={buildRelative(route)}
      scroll={SCROLL_GALLERY}
      size='sm'
    >
      <Icon name='xMark' />
    </ButtonText>
  )
}
